module.exports = __webpack_public_path__ + "img/doubloons-icon.cc6328c8.png";